import GlobalStyles from '@mui/material/GlobalStyles';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import type { ReactNode } from 'react';

import { globalStyles, THEME } from './theme';

/** The cascade layer order: MUI above the Tailwind base and below the Tailwind utilities. */
export const LAYER_ORDER = '@layer properties, theme, base, mui, components, utilities;';

/** Gives MUI the app theme. `useTheme` alone sets `.dark`, and MUI stores no mode.
 *  With `cssLayer` off, MUI styles stay out of the `mui` layer. */
export function AppThemeProvider({ cssLayer = true, children }: { cssLayer?: boolean; children: ReactNode }) {
  return (
    <StyledEngineProvider enableCssLayer={cssLayer} injectFirst={!cssLayer}>
      {cssLayer && <GlobalStyles styles={LAYER_ORDER} />}
      <ThemeProvider theme={THEME} colorSchemeNode={null} storageManager={null}>
        <GlobalStyles styles={globalStyles} />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
